import { Injectable } from '@angular/core';

@Injectable()
export class VstaticImageService {
  getImageSrc(imageName: string): string {
    if (window.location.hostname === 'localhost') {
      return `/assets/images/${imageName}`;
    }
    return `https://vstatic-prod.apigateway.co/customer-voice-client.9223372035070502651.prod/assets/images/${imageName}`;
  }
}
